export default [
    {
        path: '/group-chat-responsibles',
        name: 'group-chat-responsible',
        meta: { requiresAuth: true },
        component: () => import('@/pages/group-chat-responsible/index.vue')
    }
]
